import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { capitalize } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/utils';

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.facet.lightGray4,
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.radius.xs,
    pointerEvents: 'none',
    userSelect: 'none',
  },
  rootSizeSm: {
    transform: 'scale(0.75)',
  },
  rootSizeDefault: {},
});

const SuggestedFilterToken = ({
  className,
  classes,
  text,
  size,
}) => {
  return (
    <Typography
      className={classNames(classes.root, className, classes[`rootSize${capitalize(size)}`])}
      color={'primaryGray2'}
      variant={'h5'}
      weight={'medium'}
      test={'global-search-suggested-filter-token'}
    >
      {`${text}:`}
    </Typography>
  );
};

SuggestedFilterToken.defaultProps = {
  className: '',
  size: 'default',
};

SuggestedFilterToken.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  size: PropTypes.oneOf(['sm', 'default']),
  text: PropTypes.string.isRequired,
};

export default withStyles(styles)(SuggestedFilterToken);
